<template>
  <div class="col-md-12">
    <div class="card card-container">
      <img
        id="profile-img"
        src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
        class="profile-img-card"
      >
      <div class="text-center alert alert-success">
        در حال خروج...
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Logout',
    data () {
      return {
      }
    },
    computed: {
    },
    mounted () {
      this.handleLogout()
    },
    methods: {
      handleLogout () {
        this.$store.dispatch('auth/logout')
        this.$router.push('/login')
      },
    },
  }
</script>

<style scoped>

</style>
